<input #fileUpload type="file" id="fileUpload" (change)="fileChange($event)" [hidden]="!showInput"/> 
<button class="btn btn-primary ml-2" (click)="fileUpload.click()">
    Upload File (.xlsx)
</button>
<div class="mt-2 col">
    <div *ngIf="showValidationErrors">
        <h4>Errors with this upload: </h4>
        <ul class="list-group" *ngFor="let msg of uploadErrors; let i = index">
            <li class="list-group-item">
                <small><strong class="mr-2">{{i+1}}.</strong> {{msg}}</small>
            </li>
        </ul>
    </div>
</div>

